/* global locale languages */

const host = () => window.location.host

const langStr = (lang) => lang.startsWith('en') ? '' : `/${lang}`

$(document)
  .on('turbolinks:load', function() {
    translatePaths()
    $('.language-menu .left-menu, .language-menu .right-menu').empty()
    if (Object.keys(languages).length) {
      const leftMenu = $('.left-menu')
      const rightMenu = $('.right-menu')
      for (let i in languages) {
        let lang = languages[i]
        const href = `//${host()}${relativePath(`/${lang.locale}`, window.location)}`
        if (parseInt(i) <= languages.length/2) {
          leftMenu.append(`<li><a class="language ${lang.html_class}" href="${href}">${lang.display_name}</li>`)
        }else {
          rightMenu.append(`<li><a class="language ${lang.html_class}" href="${href}">${lang.display_name}</li>`)
        }
      }
      $('.language-label').text(window.locale.substring(0,2))
    }
  })

function translatePaths() {
  let anchors = $('a').filter('[href^="/"]')
  for (let anchor of Array.from(anchors)) {
    $(anchor).attr('href', relativePath(langStr(locale), anchor))
  }
}

function relativePath(locale, path) {
  const href = path.href.split(window.location.origin)[1]
  const currentLang = pathLang(path.pathname)
  const end = href.split(path.pathname)[1]
  const langRegex = new RegExp(`^/${currentLang}`)
  const pathname =  currentLang != '' ? path.pathname.split(langRegex)[1] : path.pathname
  return `${locale}${pathname}${end}`
}

function pathLang(path) {
  if (path == null) { path = window.location.pathname }
  const matches = pathMatch(path)
  return matches != null ? matches[1] : ''
}

function pathMatch(path) {
  return path.match(/^\/([a-z]{2}(-[A-Z]{2})?)(\/.*|$)/)
}
